import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { PlatformType } from '../models/platform-type.enum.model';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private platform = inject(Platform);

  getPlatform(): PlatformType {
    if (this.platform.is('ios')) {
      return PlatformType.iOS;
    } else if (this.platform.is('android')) {
      return PlatformType.Android;
    } else if (this.platform.is('desktop')) {
      return PlatformType.Desktop;
    }
  }
}
